/**
 * Analytics must stay off on local development hosts, even when production
 * analytics environment variables are present in a local build.
 */
export function isLocalAnalyticsHost(hostname: string): boolean {
  const host = hostname.trim().toLowerCase().replace(/^\[(.*)\]$/, "$1");

  return (
    host === "localhost" ||
    host.endsWith(".localhost") ||
    host === "0.0.0.0" ||
    host === "::1" ||
    /^127(?:\.\d{1,3}){3}$/.test(host)
  );
}
